import script from "./PersianNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PersianNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./PersianNumberInput.vue?vue&type=style&index=0&id=7f007264&scoped=true&lang=css"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f007264"],['__file',"PersianNumberInput.vue"]])

export default __exports__